import { Component, inject, Input, OnInit } from '@angular/core';
import { AbstractValueAccessorComponent, ValueAccessorUtil } from '@railmybox/shared/util';
import { PortAdminModel, PortService } from '@railmybox/api-booking';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map, switchMap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'rmb-port-select',
  templateUrl: './port-select.component.html',
  styleUrls: ['./port-select.component.scss'],
  providers: [...ValueAccessorUtil.getValueAccessorProvider(PortSelectComponent)],
  standalone: false,
})
export class PortSelectComponent extends AbstractValueAccessorComponent<string> implements OnInit {
  private portService = inject(PortService);

  ports$: Observable<PortAdminModel[]>;
  searchControl: FormControl = new FormControl(undefined);
  selectedName: string;
  @Input() filterPorts: string;
  @Input() clearable = false;

  ngOnInit(): void {
    this.ports$ = this.searchControl.valueChanges.pipe(
      untilDestroyed(this),
      switchMap((query: string) => (query ? this.portService.listPorts({ query }) : of([]))),
      map((ports: PortAdminModel[]) =>
        this.filterPorts ? ports.filter((line) => `${line.id} ${line.name}`.toLowerCase().includes(this.filterPorts.toLowerCase())) : ports
      )
    );
  }

  onSearchValueChanged(query: string): void {
    this.searchControl.patchValue(query);
  }

  onSelect(port: PortAdminModel): void {
    this.selectedName = `${port?.id} - ${port?.name}`;
    this.value = port?.id;
    this.onChange(port?.id);
    this.changed.emit(port?.id);
  }

  async writeValue(value: string): Promise<void> {
    super.writeValue(value);

    if (!value) {
      return;
    }
    const port = await this.portService
      .listPorts({ query: value })
      .toPromise()
      .then((filteredValues) => filteredValues.find((port) => port.id === value));

    // In case no entry found with that id
    if (!port) {
      return;
    }

    this.value = port.id;
    this.selectedName = `${port?.id} - ${port?.name}`;
  }
}
